import { DeleteOutlined, PlusOutlined } from '@ant-design/icons'
import {
	Button,
	Form,
	Input,
	Select,
	Switch,
	Typography,
	Space,
	Divider,
} from 'antd'
import PropTypes from 'prop-types'
import React, { useMemo, useState } from 'react'
import { ConfigCard, TitleComponent } from './styles'

const FormItem = Form.Item
const Text = Typography.Text

const DocumentTitle = ({ autoTitle }) => {
	const [autoTitleEnabled, setAutoTitleEnabled] = useState(
		autoTitle.enabled ?? false
	)

	const onChangeSwitch = (enabled) => {
		setAutoTitleEnabled(enabled)
	}

	const initialComponents = useMemo(() => {
		if (autoTitle.enabled) {
			return autoTitle.components
		} else {
			return [
				{
					component: '',
					type: 'text',
				},
			]
		}
	}, [autoTitle])

	return (
		<ConfigCard
			title="Título automático"
			extra={
				<FormItem
					name="autoTitleEnabled"
					valuePropName="checked"
					initialValue={autoTitle.enabled}>
					<Switch checked={autoTitleEnabled} onChange={onChangeSwitch} />
				</FormItem>
			}>
			{autoTitleEnabled ? (
				<>
					<Text style={{ marginBottom: '30px', display: 'block' }}>
						Acrescente componentes para criar automaticemnte o título.
						Componentes do tipo variável serão substituidos pelos valores da
						variável no moemnto da criação do documento. Você pode usar a
						variável especial <Text code>CONTADOR</Text> para acrescentar o
						número do documento ao título.
					</Text>
					<Form.List name="components" initialValue={initialComponents}>
						{(fields, { add, remove }) => (
							<>
								{fields.map(({ key, name }) => (
									<TitleComponent key={key} align="baseline" size="middle">
										<Form.Item
											label="Componente"
											name={[name, 'component']}
											style={{ width: '250px' }}
											rules={[
												{
													required: true,
													message:
														'O componente precisa de um texto ou nome de variável.',
												},
											]}>
											<Input placeholder="Texto ou variável" />
										</Form.Item>
										<Form.Item
											label="Tipo"
											name={[name, 'type']}
											initialValue="text">
											<Select
												options={[
													{
														value: 'text',
														label: 'Texto',
													},
													{
														value: 'variable',
														label: 'Variável',
													},
												]}
											/>
										</Form.Item>
										<DeleteOutlined
											style={{
												marginLeft: '30px',
												color: 'var(--ant-primary-color)',
											}}
											onClick={() => remove(name)}
										/>
									</TitleComponent>
								))}
								<Space style={{ marginTop: '10px' }}>
									<Button
										type="primary"
										onClick={() => add()}
										block
										icon={<PlusOutlined />}>
										Adicionar Componente
									</Button>
								</Space>
							</>
						)}
					</Form.List>
					<Divider />
					<FormItem
						label="Separador"
						name="separator"
						style={{ width: '50%' }}
						initialValue={autoTitle.separator}>
						<Input placeholder="Caracteres entre os componentes" />
					</FormItem>
				</>
			) : (
				<Text>
					Use esta configuração para determinar se o título será gerado
					automaticamente ou se o usuário vai precisar digitar um título no
					momento da criação do documento.
				</Text>
			)}
		</ConfigCard>
	)
}

DocumentTitle.propTypes = {
	autoTitle: PropTypes.shape({
		enabled: PropTypes.bool.isRequired,
		components: PropTypes.arrayOf(
			PropTypes.shape({
				component: PropTypes.string.isRequired,
				type: PropTypes.string.isRequired,
			})
		),
		separator: PropTypes.string.isRequired,
	}),
	form: PropTypes.object,
}

export default DocumentTitle
